module.exports = __webpack_public_path__ + "static/media/logo.97d6d66e.png";